


























































import Vue from 'vue'
import Field from '~/components/car/classifieds/form/fieldsets/fields/Field.vue'
import CTransitionExpand from '~/components/shared/configurable/expand/CTransitionExpand.vue'
import { ciAngleDownLight } from '~/icons/source/solid/angle-down-light'
import { ciAngleUpLight } from '~/icons/source/solid/angle-up-light'
import { mapState } from 'vuex'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'

export default Vue.extend({
  components: {
    CTransitionExpand,
    Field
  },
  props: {
    labelColumns: {
      type: Number,
      default: 4
    },
    fieldsColumns: {
      type: Number,
      default: 8
    },
    fields: {
      type: Array,
      default() {
        return []
      }
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    extras: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      internalIsCollapsed: this.isCollapsed
    }
  },
  computed: {
    ...mapState(CLASSIFIED_FORM_NS, {
      pageKey: state => state.pageKey
    }),
    icons() {
      return {
        expanded: ciAngleUpLight,
        collapsed: ciAngleDownLight
      }
    }
  },
  methods: {
    onFielsdetLabelClick() {
      if (!this.collapsible || !this.fields.length) {
        return
      }
      this.internalIsCollapsed = !this.internalIsCollapsed
    }
  }
})
